module.exports = __webpack_public_path__ + "media/components/homepage/static/birds2-1b973acbea389a540456a26253c3e2e8.jpg";